import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-prompt',
    templateUrl: './prompt.component.html',
    standalone: false
})
export class PromptComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<PromptComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {}

  onOk(): void {
    this.dialogRef.close(this.data.buttonText);
  }
}
